import weightLossCvQuestions, { WeightLossCVQuestionFieldAnswers } from './initial/questions';

const WeightLossCVQuestions = [...weightLossCvQuestions];
export default WeightLossCVQuestions;

export type { WeightLossCVQuestionFieldAnswers };
